// extracted by mini-css-extract-plugin
export default {"margin0":"product-part_margin0__beux3","desktopVisible":"product-part_desktopVisible__-V4ap","spinMobile":"product-part_spinMobile__sgNVQ"};